import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';


const toFormData = (item) => {
    let form_data = new FormData();

    for (let key in item) {
        form_data.append(key, item[key]);
    }
    return form_data;
}


export const spellcheckerApi = createApi({
    reducerPath: 'spellcheckerApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath(''),
        prepareHeaders: prepareAuthHeaders,
        credentials: 'include',
    }),
    endpoints: (builder) => ({
        spellChecker: builder.mutation<any, any>({
            query: ({ texts, lang }) => ({
                url: '/api/spellchecker',
                method: 'POST',
                body: { texts, lang }
            })
        }),
        suggest: builder.mutation<any, any>({
            query: (tokens) => ({
                url: '/linter/suggest/fr',
                method: 'POST',
                body: { tokens }
            })
        })
    })
});

export const { useSpellCheckerMutation, useSuggestMutation } = spellcheckerApi;
